<template>
  <a-spin :spinning="isLoading">
    <div class="forget-password">
      <div class="title">{{ $t('i18n_reset') }}{{ $t('i18n_password') }}</div>
      <div class="description">
        <i18n path="i18n_reset_user_password" tag="span">
          <span class="forget-password__name" place="name">{{ username }}</span>
        </i18n>
      </div>
      <div @keyup.enter="_handleReset">
        <a-form-model ref="form" class="form" :rules="rules" :model="formData">
          <a-form-model-item :label="$t('i18n_new_password')" prop="password">
            <a-input-password
              ref="passwordInput"
              v-model="formData.password"
              :placeholder="$t('i18n_password_pattern')"
            />
          </a-form-model-item>
          <a-form-model-item
            :label="$t('i18n_confirm_password')"
            prop="repeatPassword"
          >
            <a-input-password
              v-model="formData.repeatPassword"
              :placeholder="$t('i18n_input_password_again')"
            />
          </a-form-model-item>
          <a-button type="primary" @click="_handleReset">
            {{ $t('i18n_confirm') }}
          </a-button>
        </a-form-model>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { newPassword } from './utils'
import { getFormModelRule } from '@G/utils/other'

export default {
  name: 'PasswordReset',
  data() {
    return {
      isLoading: false,
      isError: false,
      code: '',
      username: this.$route.params.username,
      formData: {
        password: '',
        repeatPassword: '',
        identityUUID: this.$route.params.identityUUID,
        requestToken: this.$route.params.requestToken
      },
      rules: {
        password: [
          ...getFormModelRule(newPassword),
          { validator: this._handleCheck }
        ],
        repeatPassword: {
          validator: this._handleCheckRepeatPassword,
          trigger: 'blur'
        }
      }
    }
  },
  mounted() {
    this.$refs.passwordInput.focus()
  },
  methods: {
    _handleReset() {
      this.isError = false
      this.$refs.form.validate(async error => {
        if (error) {
          this.isLoading = true
          const {
            isError,
            code,
            toLink,
            params
          } = await this.$authProvider.resetPassword(this.formData)
          if (isError) {
            this.isError = true
            this.code = code
            this.$refs.form.validate(() => {})
          } else {
            this.$router.push({ name: toLink, params })
          }
          this.isLoading = false
        }
      })
    },
    _handleCheckRepeatPassword(rule, value, callback) {
      if (value !== this.formData.password) {
        callback(new Error(this.$t('i18n_password_error_different')))
      } else {
        callback()
      }
    },
    _handleCheck(rule, value, callback) {
      if (this.isError) {
        // TODO i18n 準確的 text
        callback(this.$t(`i18n_code_${this.code}`))
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@THEME_VARS';

.forget-password__name {
  color: $auth-label-color;
}
</style>
